import Cojiro from "../../../core/assets/oot/gshd/blue-chicken_32x32.png";
import BrokenGoronSword from "../../../core/assets/oot/gshd/broken-bgs_32x32.png";
import Cucco from "../../../core/assets/oot/gshd/chicken_32x32.png";
import ClaimCheck from "../../../core/assets/oot/gshd/claim-check_32x32.png";
import WeirdEgg from "../../../core/assets/oot/gshd/egg_32x32.png";
import Eyedrop from "../../../core/assets/oot/gshd/eye-drops_32x32.png";
import Frog from "../../../core/assets/oot/gshd/kz-frog_32x32.png";
import OddMushroom from "../../../core/assets/oot/gshd/mushroom_32x32.png";
import OddPotion from "../../../core/assets/oot/gshd/odd-potion_32x32.png";
import Prescription from "../../../core/assets/oot/gshd/prescription_32x32.png";
import PoacherSaw from "../../../core/assets/oot/gshd/saw_32x32.png";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import UpgradeItem from "../../../core/items/UpgradeItem";
import OotItem, { DbItemProps } from "./OotItem";

interface AdultSequenceItemProps{
    type?: "all" | "last"

}

const id = "OoT_AdultSequence"
let firstSequence = [WeirdEgg, Cucco, Cojiro, OddMushroom, OddPotion, PoacherSaw, BrokenGoronSword]
let lastSequence = [Prescription, Frog, Eyedrop, ClaimCheck]

const AdultSequenceItem = (props: AdultSequenceItemProps) => {

    let images = props.type === "all" ? [...firstSequence, ...lastSequence] : [...lastSequence] 

    return <OotItem id={id}>
            {({ updateOotItem, item }) => {
                return <UpgradeItem id={id} image={images} item={item} updateItem={updateOotItem} isMajor
                    title={["Weird Egg", "Cucco", "Zelda's Letter", "Keaton Mask", "Skull Mask", "Spooky Mask", "Mask of Truth"]} upgradeLabel={["", "", "", "", "", "", ""]} />

            }}
        </OotItem>


}

export default AdultSequenceItem;

interface DbAdultSequenceItemProps extends AdultSequenceItemProps, DbItemProps {}

export const DbAdultSequenceItem = (props: DbAdultSequenceItemProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultAdultSequenceItem;

    let images = props.type === "all" ? [...firstSequence, ...lastSequence] : [...lastSequence] 

    return <UpgradeItem
        item={item}
        updateItem={props.update}
        image={images}
        id={id}
        isObtained={item.isObtained}
        title={["Weird Egg", "Cucco", "Zelda's Letter", "Keaton Mask", "Skull Mask", "Spooky Mask", "Mask of Truth"]} upgradeLabel={["", "", "", "", "", "", ""]}
    />


}

const DefaultAdultSequenceItem : ItemLightDto = {
    id: id,
    title: id,
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}